module.exports = __webpack_public_path__ + "img/rg4.f9777d1d.jpg";